import { BrowserRouter as Router, useRoutes } from "react-router-dom"
import { RootStoreContext } from "./stores/RootStoreContext"
import { RootStore } from "./stores/RootStore"
import { SignUp } from "./components/SignUp"
import { SignIn } from "./components/SignIn"
import { Confirm } from "./components/Confirm"
import { Forgot } from "./components/Forgot"
import { Reset } from "./components/Reset"
import { MainPage } from "./components/common/page/MainPage"
import { CompanyAdmin } from "./components/admin/company/CompanyAdmin"
import { CompanyList } from "./components/admin/company/CompanyList"
import { CompanyPage } from "./components/common/page/CompanyPage"
import { BrockmanAdmin } from "./components/admin/brockman/BrockmanAdmin"
import { BrockmanBillDetail } from "./components/admin/brockman/BrockmanBillDetail"
import { UserList } from "./components/admin/user/UserList"
import { ContractorClient } from "./components/client/contragent/ContractorClient"
import { ContractorListClient } from "./components/client/contragent/ContractorListClient"
import { ClientCompanyList } from "./components/client/company/ClientCompanyList"
import { RequestList } from "./components/common/page/RequestList"
import { ReplenishmentList } from "./components/common/page/ReplenishmentList"
import { Replenishment } from "./components/common/page/Replenishment"
import { Bill } from "./components/client/replenishment/Bill"
import { OrderList } from "./components/common/page/OrderList"
import { Order } from "./components/common/page/Order"
import { UserInfo } from "./components/common/page/UserInfo"
import ExchangeRates from "./components/common/page/ExchangeRates"
import { BrockmanManager } from "./components/manager/brockman/BrockmanManager"
import { RateSettings } from "./components/admin/settings"
import { BaseClientRates } from "./components/client/baseRates"
import { ManagerBalance } from "./components/manager/balance"
import { InvoicesHistoryUpload } from "./components/manager/balance/Upload"
import {
  ADMIN_BROCKMAN_DETAIL_ROUTE,
  ADMIN_BROCKMAN_VIEW_ROUTE,
  ADMIN_COMPANY_ROUTE,
  ADMIN_COMPANY_VIEW_ROUTE,
  ADMIN_RATE_SETTINGS_ROUTE,
  ADMIN_USER_ROUTE,
  ADMIN_USER_VIEW_ROUTE,
  CLIENT_COMPANY_ROUTE,
  CLIENT_CONTRACTOR_ROUTE,
  CLIENT_CONTRACTOR_VIEW_ROUTE,
  COMPANY_VIEW_ROUTE,
  DASHBOARD_ROUTE,
  FORGOT_ROUTE,
  HOMEPAGE_ROUTE,
  MANAGER_BROCKMAN_VIEW_ROUTE,
  ORDER_ROUTE,
  ORDER_VIEW_ROUTE,
  PROFILE_ROUTE,
  BASE_RATES,
  RATES_ROUTE,
  REPLENISHMENT_BILL_ROUTE,
  REPLENISHMENT_ROUTE,
  REPLENISHMENT_VIEW_ROUTE,
  REQUEST_ROUTE,
  RESET_CONFIRMATION_ROUTE,
  SIGN_IN_ROUTE,
  SIGN_UP_ROUTE,
  USER_CONFIRMATION_ROUTE,
  BALANCE_ROUTE,
  BALANCE_UPLOAD_ROUTE,
  CURRENCY_EXCHANGE_ROUTE,
  CURRENCY_REPLENISHMENT_ROUTE,
  CURRENCY_REPLENISHMENT_VIEW_ROUTE,
  CURRENCY_REPLENISHMENT_BILL_ROUTE
} from "./routes"
import { CurrencyExchange } from "./components/manager/currencyExchange"
import { CurrencyReplenishmentList } from "./components/common/page/CurrencyReplenishmentList"
import { CurrencyReplenishment } from "./components/common/page/CurrencyReplenishment"
import { CurrencyBill } from "./components/client/currencyReplenishment/CurrencyBill"

const App = () => {
  return useRoutes([
    { path: HOMEPAGE_ROUTE, element: <SignIn /> },
    { path: SIGN_UP_ROUTE, element: <SignUp /> },
    { path: SIGN_IN_ROUTE, element: <SignIn /> },
    { path: USER_CONFIRMATION_ROUTE, element: <Confirm /> },
    { path: FORGOT_ROUTE, element: <Forgot /> },
    { path: RESET_CONFIRMATION_ROUTE, element: <Reset /> },
    { path: DASHBOARD_ROUTE, element: <MainPage /> },
    { path: ADMIN_COMPANY_ROUTE, element: <CompanyList /> },
    { path: ADMIN_COMPANY_VIEW_ROUTE, element: <CompanyAdmin /> },
    { path: ADMIN_BROCKMAN_VIEW_ROUTE, element: <BrockmanAdmin /> },
    { path: ADMIN_BROCKMAN_DETAIL_ROUTE, element: <BrockmanBillDetail /> },
    { path: ADMIN_USER_ROUTE, element: <UserList /> },
    { path: ADMIN_USER_VIEW_ROUTE, element: <UserInfo /> },
    { path: ADMIN_RATE_SETTINGS_ROUTE, element: <RateSettings /> },
    { path: PROFILE_ROUTE, element: <UserInfo /> },
    { path: COMPANY_VIEW_ROUTE, element: <CompanyPage /> },
    { path: RATES_ROUTE, element: <ExchangeRates /> },
    { path: MANAGER_BROCKMAN_VIEW_ROUTE, element: <BrockmanManager /> },
    { path: BALANCE_ROUTE, element: <ManagerBalance /> },
    { path: CURRENCY_EXCHANGE_ROUTE, element: <CurrencyExchange /> },
    { path: BALANCE_UPLOAD_ROUTE, element: <InvoicesHistoryUpload /> },

    { path: CLIENT_CONTRACTOR_ROUTE, element: <ContractorListClient /> },
    { path: CLIENT_CONTRACTOR_VIEW_ROUTE, element: <ContractorClient /> },
    { path: CLIENT_COMPANY_ROUTE, element: <ClientCompanyList /> },
    { path: BASE_RATES, element: <BaseClientRates /> },

    { path: REQUEST_ROUTE, element: <RequestList /> },
    { path: REPLENISHMENT_ROUTE, element: <ReplenishmentList /> },
    { path: REPLENISHMENT_VIEW_ROUTE, element: <Replenishment /> },
    { path: REPLENISHMENT_BILL_ROUTE, element: <Bill /> },
    { path: CURRENCY_REPLENISHMENT_ROUTE, element: <CurrencyReplenishmentList /> },
    { path: CURRENCY_REPLENISHMENT_VIEW_ROUTE, element: <CurrencyReplenishment /> },
    { path: CURRENCY_REPLENISHMENT_BILL_ROUTE, element: <CurrencyBill /> },
    { path: ORDER_ROUTE, element: <OrderList /> },
    { path: ORDER_VIEW_ROUTE, element: <Order /> }
  ])
}

const AppWrapper = () => {
  return (
    <RootStoreContext.Provider value={new RootStore()}>
      <Router>
        <App />
      </Router>
    </RootStoreContext.Provider>
  )
}

export default AppWrapper
